import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ProgramService extends BaseSearchableService {
    get Url() { return super.Url + "/programs"; }
    get ModelName() { return "Programs"; }
    get PrimaryKeyProperty() { return "programId"; }

    GetPrograms() {
        return this.SendRequest(BaseService.GET);
    }

    Search(name, additionalParameters = null) {
        let request = {
            name: name,
            ...additionalParameters
        };

        return this.SendRequest(BaseService.GET, request);
    }

    GetChildrenPrograms(parentId) {
        let request = {parentId: parentId};
        return this.SendRequest(BaseService.GET, request);
    }

    GetProgram(programId) {
        return this.SendRequest(BaseService.GET, programId);
    }

    UpdateProgram(program) {
        return this.SendRequest(BaseService.PUT, program);
    }

    CreateProgram(program) {
        return this.SendRequest(BaseService.POST, program);
    }

    DeleteProgram(programId) {
        return this.SendRequest(BaseService.DELETE, programId);
    }
}

export const service = new ProgramService();

